import { useNavigate } from 'react-router-dom';

import MenuIcon from '@mui/icons-material/Menu';

import Exit from '../images/exit.png';
import './Header.css';

function Header(props: any) {
    const { title, companyName, setLogin, color, onMenuToggle, isMobile = false } = props;

    const navigate = useNavigate();

    const onLogout = () => {
        localStorage.removeItem('token');
        setLogin(false);
        navigate('/login');
    };

    const containerClasses = ['head', color === 'dark' ? 'dark' : 'light'];
    if (isMobile) {
        containerClasses.push('head--mobile');
    }

    return (
        <div className={`${containerClasses.join(' ')} sticky top-0 z-40`}>
            {isMobile ? (
                <button
                    type='button'
                    className='head__menuButton'
                    onClick={onMenuToggle}
                    aria-label='Toggle navigation menu'
                >
                    <MenuIcon fontSize='medium' />
                </button>
            ) : null}
            <div className='head__title'>{title}</div>
        </div>
    );
}

export default Header;
